class ContactCheckBox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).find('input[type=checkbox],input[type=radio]').each(function(){
      if($(this).prop('checked') == true){
        $(this).parent('label').addClass('is-active');
      }else{
        $(this).parent('label').removeClass('is-active');
      }
    })
    $("." + this.el).find('input[type=checkbox]').on('change',function(){
      if($(this).prop('checked') == true){
        $(this).parent('label').addClass('is-active');
      }else{
        $(this).parent('label').removeClass('is-active');
      }
    })
    $("." + this.el).find('input[type=radio]').on('change',function(){
      let radioName = $(this).attr('name');
      $('[name='+radioName+']').each(function(){
        if($(this).prop('checked') == true){
          $(this).parent('label').addClass('is-active');
        }else{
          $(this).parent('label').removeClass('is-active');
        }
      })
    })
  }
}
